/* Postrly quick view v2 — modal from /products/{handle}.js. Size/frame
   pills + digital card + quantity, AJAX add, opens cart drawer. Focus
   trap, Escape/overlay close. Robust against card-link click-through. */
(function () {
  'use strict';
  var DIGITAL = 'Digital File Download';
  var lastFocus = null;

  function money(cents) {
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function overlay() { return document.getElementById('postrly-qv'); }
  function close() {
    var o = overlay();
    if (!o || o.hidden) return;
    o.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function trap(e) {
    var o = overlay();
    if (!o || o.hidden || e.key !== 'Tab') return;
    var f = o.querySelectorAll('button, [href], input, select, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }

  function build(p) {
    var o = overlay();
    if (!o) return;
    var box = o.querySelector('.pqv__box');
    var img = (p.media && p.media[0] && p.media[0].preview_image && p.media[0].preview_image.src) || p.featured_image || '';
    if (img) img = img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=600';
    var variants = p.variants.map(function (v) { return { id: v.id, o1: v.option1, o2: v.option2, price: v.price, available: v.available }; });
    var digital = variants.filter(function (v) { return v.o1 === DIGITAL; })[0] || null;
    var sizes = [], frames = [];
    variants.forEach(function (v) {
      if (v.o1 !== DIGITAL && sizes.indexOf(v.o1) === -1) sizes.push(v.o1);
      if (v.o2 && frames.indexOf(v.o2) === -1) frames.push(v.o2);
    });
    var state = { size: null, frame: frames[0] || null, digital: false, prevSize: null, prevFrame: null, qty: 1 };
    for (var i = 0; i < sizes.length && !state.size; i++) {
      var s = sizes[i];
      if (variants.some(function (v) { return v.o1 === s && v.available; })) state.size = s;
    }
    if (!state.size && digital) state.digital = true;

    function find(o1, o2) {
      for (var i = 0; i < variants.length; i++) if (variants[i].o1 === o1 && (o2 === null || variants[i].o2 === o2)) return variants[i];
      return null;
    }
    function resolve() { return state.digital ? find(DIGITAL, null) : (find(state.size, state.frame) || find(state.size, null)); }

    var html = '';
    html += '<button type="button" class="pqv__x" data-qv-close aria-label="Close quick view">&#10005;</button>';
    html += '<div class="pqv__grid">';
    html += '<div class="pqv__media">' + (img ? '<img src="' + img + '" alt="" width="300" height="400">' : '') + '</div>';
    html += '<div class="pqv__info">';
    html += '<p class="pqv__title">' + p.title + '</p>';
    html += '<p class="pqv__price" data-qv-price></p>';
html += '<p class="pqv__offer"><b>Buy 3, Get 1 Free</b> + Free Shipping</p>';
    if (sizes.length) {
      html += '<p class="pqv__label">Size</p><div class="pqv__pills" data-qv-sizes>';
      sizes.forEach(function (s) { html += '<button type="button" class="pqv__pill" data-qv-size="' + s.replace(/"/g, '&quot;') + '">' + s + '</button>'; });
      html += '</div>';
    }
    if (frames.length > 1) {
      html += '<p class="pqv__label">Frame</p><div class="pqv__pills" data-qv-frames>';
      frames.forEach(function (f) { html += '<button type="button" class="pqv__pill" data-qv-frame="' + f.replace(/"/g, '&quot;') + '">' + f + '</button>'; });
      html += '</div>';
    }
    if (digital && digital.available) {
      html += '<label class="pqv__digital"><input type="checkbox" data-qv-digital' + (state.digital ? ' checked' : '') + '> <span><b>Just want the digital file?</b> Instant download — ' + money(digital.price) + '</span></label>';
    }
    html += '<div class="pqv__qty" aria-label="Quantity"><button type="button" data-qv-minus aria-label="Decrease quantity">−</button><input type="number" min="1" value="1" data-qv-qtyin aria-label="Quantity"><button type="button" data-qv-plus aria-label="Increase quantity">+</button></div>';
    html += '<button type="button" class="pqv__atc" data-qv-atc>Add to cart</button>';
    html += '<a class="pqv__full" href="' + p.url + '">View full details</a>';
    html += '</div></div>';
    box.innerHTML = html;

    var priceEl = box.querySelector('[data-qv-price]');
    function paint() {
      var v = resolve();
      box.classList.toggle('is-digital', state.digital);
      if (v && priceEl) priceEl.textContent = money(v.price * state.qty) + (state.qty > 1 ? ' (' + state.qty + ')' : '');
      box.querySelectorAll('[data-qv-size]').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-qv-size') === state.size);
        var av = variants.some(function (vv) { return vv.o1 === b.getAttribute('data-qv-size') && (!state.frame || vv.o2 === state.frame) && vv.available; });
        b.disabled = !av;
      });
      box.querySelectorAll('[data-qv-frame]').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-qv-frame') === state.frame);
        var av = variants.some(function (vv) { return vv.o1 === state.size && vv.o2 === b.getAttribute('data-qv-frame') && vv.available; });
        b.disabled = !av;
      });
    }

    var qtyIn = box.querySelector('[data-qv-qtyin]');
    box.addEventListener('click', function (e) {
      var s = e.target.closest('[data-qv-size]');
      var f = e.target.closest('[data-qv-frame]');
      if (s && !s.disabled && !state.digital) { state.size = s.getAttribute('data-qv-size'); paint(); }
      if (f && !f.disabled && !state.digital) { state.frame = f.getAttribute('data-qv-frame'); paint(); }
      if (e.target.closest('[data-qv-minus]')) { state.qty = Math.max(1, state.qty - 1); qtyIn.value = state.qty; paint(); }
      if (e.target.closest('[data-qv-plus]')) { state.qty = state.qty + 1; qtyIn.value = state.qty; paint(); }
    });
    if (qtyIn) qtyIn.addEventListener('change', function () { state.qty = Math.max(1, parseInt(qtyIn.value, 10) || 1); qtyIn.value = state.qty; paint(); });
    var dig = box.querySelector('[data-qv-digital]');
    if (dig) dig.addEventListener('change', function () {
      if (dig.checked) { state.prevSize = state.size; state.prevFrame = state.frame; state.digital = true; }
      else { state.digital = false; if (state.prevSize) state.size = state.prevSize; if (state.prevFrame) state.frame = state.prevFrame; }
      paint();
    });
    var atc = box.querySelector('[data-qv-atc]');
    atc.addEventListener('click', function () {
      var v = resolve();
      if (!v || atc.disabled) return;
      atc.disabled = true;
      atc.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: state.qty }] })
      })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () {
          close();
          if (window.postrlyRefreshCartDrawer) return window.postrlyRefreshCartDrawer(true);
        })
        .catch(function () { atc.textContent = 'Try again'; atc.disabled = false; });
    });
    paint();
    var x = box.querySelector('[data-qv-close]');
    if (x) x.focus();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-postrly-qv]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      lastFocus = btn;
      var url = btn.getAttribute('data-postrly-qv');
      var o = overlay();
      if (!o) return;
      o.hidden = false;
      document.body.style.overflow = 'hidden';
      o.querySelector('.pqv__box').innerHTML = '<p class="pqv__loading">Loading…</p>';
      fetch(url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(build)
        .catch(function () {
          var b = o.querySelector('.pqv__box');
          if (b) b.innerHTML = '<p class="pqv__loading">Couldn’t load this product. <a href="' + url + '">Open the product page</a>.</p>';
        });
      return;
    }
    var o = overlay();
    if (o && !o.hidden && e.target === o) close();
    if (e.target.closest && e.target.closest('[data-qv-close]')) close();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    trap(e);
  });
})();
